import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectBillingOverview } from './useClientBilling.utils';
import { useClientInvoices } from './useClientInvoices';
const EMPTY_SELECTION = {
    upcomingInvoice: null,
    latestInvoice: null,
    overdueInvoices: []
};
export function useClientBilling(customerId) {
    let { refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _futureQuery_data;
    const { api } = useStoreActions();
    const { invoices, isLoading: isInvoicesLoading, isError: isInvoicesError, refetch: refetchInvoices } = useClientInvoices(customerId, {
        refreshOnHookMount
    });
    const futureQuery = useQueryState({
        queryKey: [
            QueryKeys.ClientFutureInvoices,
            customerId
        ],
        queryFn: ()=>api.reports.getFutureInvoicesByCustomer(customerId),
        enabled: customerId != null,
        refreshOnHookMount
    });
    const refetch = ()=>{
        refetchInvoices();
        void futureQuery.refresh({
            throwOnError: false
        });
    };
    if (customerId == null) {
        return {
            billing: EMPTY_SELECTION,
            isLoading: false,
            isError: false,
            refetch
        };
    }
    if (isInvoicesLoading || futureQuery.isLoading) {
        return {
            billing: EMPTY_SELECTION,
            isLoading: true,
            isError: false,
            refetch
        };
    }
    if (isInvoicesError || futureQuery.error != null) {
        return {
            billing: EMPTY_SELECTION,
            isLoading: false,
            isError: true,
            refetch
        };
    }
    const futures = (_futureQuery_data = futureQuery.data) !== null && _futureQuery_data !== void 0 ? _futureQuery_data : [];
    return {
        billing: selectBillingOverview(invoices, futures),
        isLoading: false,
        isError: false,
        refetch
    };
}
